"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore. Prevent gatsby blowing up.
var newWindow = typeof window !== 'undefined' ? window : {};
// eslint-disable-next-line
exports.default = newWindow;
